import React from 'react';
import { Button as AntdButton, ConfigProvider } from 'antd';

import styles from '../button/index.module.scss';
import cx from 'clsx';
import Icon from '../icon';
import ConfigDB from '../../../data/customizer/theme';

const ButtonSecondary = ({
  shape,
  size,
  type = 'primary',
  icon,
  iconPosition,
  iconSize,
  iconColor,
  iconHasBackground,
  iconBgSize,
  iconBgColor,
  onClick,
  children,
  text,
  style,
  className,
  bordered,
  htmlType,
  loading = false,
  wide,
  disabled = false,
  ...rest
}) => {
  const colorSecondary = ConfigDB?.data?.color?.secondary_color;

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: colorSecondary,
        },
      }}
    >
      <AntdButton
        shape={shape}
        size={size}
        type={type}
        {...(icon
          ? {
              icon: (
                <Icon
                  icon={icon}
                  iconSize={iconSize}
                  color={type === 'primary-light-secondary' ? 'var(--ant-color-primary)' : iconColor}
                  hasBackground={iconHasBackground}
                  bgSize={iconBgSize}
                  bgColor={iconBgColor}
                />
              ),
            }
          : {})}
        iconPosition={iconPosition}
        onClick={onClick}
        className={cx(className, styles.btn, bordered && 'ant-btn-bordered', wide && styles.btnWide)}
        style={style}
        htmlType={htmlType}
        loading={loading}
        disabled={disabled}
        {...rest}
      >
        {children || text}
      </AntdButton>
    </ConfigProvider>
  );
};

export default ButtonSecondary;
